import { Injectable } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { SelectClientModalComponent } from './select-client-modal.component';

@Injectable()
export class SelectClientModalService {

  constructor(private dialog: MatDialog) { }

  openModal(): Observable<any> {
    let dialogRef: MatDialogRef<SelectClientModalComponent>;
    dialogRef = this.dialog.open(SelectClientModalComponent, {
        disableClose: true,
        // width: '300px'
    });
    // dialogRef.updateSize('380px');
    return dialogRef.afterClosed();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/select-client-modal/select-client-modal.service.ts